import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ShipmentsPickupPage',
    defaultMessage: 'Shipments > Pickup',
    id: 'HmHw6Z',
  },
});

export const hotkey = ['g', 'k'];
export const barcodeContent = '+4LVDH8YFM689=';

const GotoShipmentsPickupPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/shipments/pickup'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gk'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoShipmentsPickupPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoShipmentsPickupPage;
